import React from 'react';

const BodyCompAnalyerCompo = () => {
    return (
        <div className='mx-auto mb-10'>
            <h1 className='text-md my-5'>Segmental/Medical body composition analyzer describes the
                analysis of the body composition , current state of body water,
                protein, minerals, and fat to provide more precise information
                beyond weight and BMI. Gives you a complete picture about
                where you are and how you need to train.</h1>



            {/* <div className="schedule lg:mb-20 md:mb-16 sm:mb-10 mb-10 md:flex items-center">
                <div className="schedule_time w-full">
                    <div className="overflow-x-auto">
                        <table className="table table-zebra table_border table-compact w-full">
                            <thead className='table_border rounded-2xl'>
                                <tr >
                                    <th>Validity</th>
                                    <th>Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="hover">
                                    <td>60 days from purchase</td>
                                    <td>For CrossFit/Legion</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h1 className='font-semibold mt-2'>Classes: Max 20 classes per month</h1>
                </div>
            </div> */}

        </div>
    );
};

export default BodyCompAnalyerCompo;